import EasySetup from "../../../../assets/icons/easy-setup.svg";
import NoSubscriptions from "../../../../assets/icons/no-subscriptions.svg";
import Quality from "../../../../assets/icons/hd-quality.svg";
import s from "./QuizEndIcons.module.scss";

const fallBackIcons = [
  {
    image: EasySetup,
    tr_image_text: "Easy Setup",
  },
  {
    image: NoSubscriptions,
    tr_image_text: "No Subscriptions",
  },
  {
    image: Quality,
    tr_image_text: "HD Quality",
  },
];

const base = window.post_template.checkout_v4_quiz;
const quizImageSection = base?.quiz_icons_and_text_repeater || fallBackIcons;

const QuizEndIcons = () => {
  return (
    <div className={s["quiz__images"]}>
      {quizImageSection.map((item, index) => (
        <div key={index} className={s["quiz__images--container"]}>
          <img className={s["quiz__images--icon"]} src={item.image} alt={item.tr_image_text} />
          <p className={s["quiz__images--paragraph"]}>{item.tr_image_text}</p>
        </div>
      ))}
    </div>
  );
};

export default QuizEndIcons;
